import { Component, ComponentFactoryResolver, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ApiError, AuthService, BaseVisualizacaoService, ConfigService, DataTablesColumnSettings, DataTablesService, MessageService, Task, TaskService, VisualizacaoStorageService } from '../../../../core';
import { ClienteCarteiraCongelarModalComponent, ClienteCarteiraCongelarHttpService } from '../../../cliente-carteira/congelar';
import { ClienteCarteiraBaixarHttpService, ClienteCarteiraBaixarModalComponent } from '../../../cliente-carteira/baixar';
import { ClienteCarteiraPreBaixarHttpService, ClienteCarteiraPreBaixarModalComponent } from '../../../cliente-carteira/prebaixar';
import { CanalMidiaSocialIconPipe, CanalMidiaSocialPipe } from '../../../common/canal-midia-social/pipes';
import { OrigemIconPipe, OrigemPipe } from '../../../common/origens/pipes';
import { ConfigEmpresa, createNomeRepresentante, isConfigEmpresaVersaoIntegracaoErp1 } from '../../../configuracoes/app/empresa';
import { IntegrationClienteHttpService } from '../../../configuracoes/integration/cliente';
import { funilVendaFaseTipoOportunidade } from '../../../crm/funil-venda/fase';
import { NegocioFormInsertModalComponent } from '../../../crm/negocio/form-insert';
import { PessoaTipoBadgeComponent } from '../../tipo/components/badge';
// import { NegocioOportunidadeFormModalComponent } from "../../../crm/negocio/oportunidade/form/modal/negocio-oportunidade-form-modal.component";
import { Representante } from '../../representante';
import { ClienteAnaliseFinanceiraConcluirModalComponent } from '../analise-financeira/concluir-modal';
import { ClienteAnaliseFinanceiraRevisarModalComponent } from '../analise-financeira/revisar-modal';
import { ClienteAnaliseFinanceiraAuthGuardService, ClienteAnaliseFinanceiraConcluirHttpService, ClienteAnaliseFinanceiraIniciarHttpService } from '../analise-financeira/services';
import { ClienteAnaliseFinanceiraStatusBadgeComponent } from '../analise-financeira/status/badge';
import { ClienteCadastroBadgePipe, ClienteCadastroPipe } from '../cadastro/pipes';
import { Cliente } from '../cliente';
import { ClienteSearchOrderBy } from '../cliente-search-orderby';
import { ClienteOptionsActions, ClienteTableOptions } from '../cliente-table-options';
import { ClienteFilter } from '../filter';
import { ClienteIntegracaoErpImportHttpService } from '../integracoes/erp/import';
import { ClienteNomePipe } from '../pipes/cliente-nome.pipe';
import { ClienteAuthGuardService, ClienteCrudHttpService, ClienteReportService } from '../services';
import { ClienteSituacaoBadgePipe, ClienteSituacaoPipe } from '../situacao/pipes';
@Component({
    selector: 'sgt-cliente-list',
    templateUrl: './cliente-list.component.html',
    styleUrls: ['./cliente-list.component.less'],
    providers: [
        ClienteNomePipe,
        ClienteCadastroPipe,
        ClienteCadastroBadgePipe,
        ClienteSituacaoPipe,
        ClienteSituacaoBadgePipe,
        OrigemPipe,
        OrigemIconPipe,
        CanalMidiaSocialPipe,
        CanalMidiaSocialIconPipe
    ]
})
export class ClienteListComponent implements OnInit, OnDestroy {
    private searchSubs$: Subscription;
    configEmpresa: ConfigEmpresa;
    isIntegracaoErpV1: boolean;
    isAdministrador: boolean;
    isAtendente: boolean;
    isRepresentante: boolean;
    isFinanceiro: boolean;

    @Input() idDataTable = 'tableClientes';
    dataTable: any;
    quantidadeClientes = 0;

    @Input() optionsVisibility: ClienteOptionsActions = {
        canEdit: true,
        canPrintFichaCadastral: true,
        canImportOneErp_v1: true,
        canImportOneErp: true,
        // Negócio
        canInsertNegocio: true,
        // Análise Financeira
        canIniciarAnaliseFinanceira: true,
        canCancelarIniciarAnaliseFinanceira: true,
        canConcluirAnaliseFinanceira: true,
        canCancelarConcluirAnaliseFinanceira: true,
        canRevisarAnaliseFinanceira: true,
        // Congelar
        canCongelar: true,
        canDescongelar: true,
        // Pré-Baixar
        canPreBaixar: true,
        canEditPreBaixa: true,
        canCancelarPreBaixa: true,
        // Baixar
        canBaixar: true,
        canEditBaixa: true,
        canCancelarBaixa: true
    }

    @Input() visualizacaoStorageKey = 'clienteListVisualizacao';
    @Input() filter = new ClienteFilter();
    orderBy: number;
    @Output() orderByChanged = new EventEmitter<number>();
    orderByDir: string;
    @Output() orderByDirChanged = new EventEmitter<string>();

    /** Container para criar dinamicamente os badges dos tipos das pessoas */
    @ViewChild('pessoaTipoBadgeContainer', {read: ViewContainerRef}) pessoaTipoBadgeContainer: ViewContainerRef;
    /** Container para criar dinamicamente os badges do status da análise financeira */
    @ViewChild('analiseFinanceiraStatusBadgeContainer', {read: ViewContainerRef}) analiseFinanceiraStatusBadgeContainer: ViewContainerRef;
    @ViewChild('analiseFinanceiraConcluirModal') analiseFinanceiraConcluirModal: ClienteAnaliseFinanceiraConcluirModalComponent;
    @ViewChild('analiseFinanceiraRevisarModal') analiseFinanceiraRevisarModal: ClienteAnaliseFinanceiraRevisarModalComponent;

    @ViewChild('clienteCarteiraCongelarModal') clienteCarteiraCongelarModal: ClienteCarteiraCongelarModalComponent;
    @ViewChild('clienteCarteiraPreBaixarModal') clienteCarteiraPreBaixarModal: ClienteCarteiraPreBaixarModalComponent;
    @ViewChild('clienteCarteiraBaixarModal') clienteCarteiraBaixarModal: ClienteCarteiraBaixarModalComponent;

    // Negócio Form Insert
    @ViewChild('formInsertModal') formInsertModal: NegocioFormInsertModalComponent
    // Oportunidade form
    // @ViewChild('formOportunidadeModal') formOportunidadeModal: NegocioOportunidadeFormModalComponent;

    constructor(private componentFactoryResolver: ComponentFactoryResolver,
                private renderer: Renderer2,
                private activatedRoute: ActivatedRoute,
                private el: ElementRef,
                private authService: AuthService,
                private baseVisualizacaoService: BaseVisualizacaoService,
                private configService: ConfigService,
                private visualizacaoStorageService: VisualizacaoStorageService,
                private messageService: MessageService,
                private dataTablesService: DataTablesService,
                private taskService: TaskService,
                private clienteNomePipe: ClienteNomePipe,
                private clienteAuthGuardService: ClienteAuthGuardService,
                private clienteCrudHttpService: ClienteCrudHttpService,
                private clienteReportService: ClienteReportService,
                private clienteCadastroPipe: ClienteCadastroPipe,
                private clienteCadastroBadgePipe: ClienteCadastroBadgePipe,
                private clienteSituacaoPipe: ClienteSituacaoPipe,
                private clienteSituacaoBadgePipe: ClienteSituacaoBadgePipe,
                private origemPipe: OrigemPipe,
                private origemIconPipe: OrigemIconPipe,
                private canalMidiaSocialPipe: CanalMidiaSocialPipe,
                private canalMidiaSocialIconPipe: CanalMidiaSocialIconPipe,
                private integrationClienteHttpService: IntegrationClienteHttpService,
                private clienteIntegracaoErpImportHttpService: ClienteIntegracaoErpImportHttpService,
                private clienteAnaliseFinanceiraAuthGuardService: ClienteAnaliseFinanceiraAuthGuardService,
                private clienteAnaliseFinanceiraIniciarHttpService: ClienteAnaliseFinanceiraIniciarHttpService,
                private clienteAnaliseFinanceiraConcluirHttpService: ClienteAnaliseFinanceiraConcluirHttpService,
                private clienteCarteiraCongelarHttpService: ClienteCarteiraCongelarHttpService,
                private clienteCarteiraPreBaixarHttpService: ClienteCarteiraPreBaixarHttpService,
                private clienteCarteiraBaixarHttpService: ClienteCarteiraBaixarHttpService) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();
        this.isIntegracaoErpV1 = isConfigEmpresaVersaoIntegracaoErp1(this.configEmpresa);
        this.isAdministrador = this.authService.isAdministrador();
        this.isAtendente = this.authService.isAtendente();
        this.isRepresentante = this.authService.isRepresentante();
        this.isFinanceiro = this.authService.isFinanceiro();
    }

    search() {
        this.searchSubs$?.unsubscribe();
        this.searchSubs$ = new Subscription();

        if (!this.dataTable) {
            // Obtendo os dados armazenados da visualização
            const vs = this.visualizacaoStorageService.get();
            // Criando a dataTable assíncrona
            this.createTable().then(() => {
                // Se possuir dados armazenados, então aplicamos eles na dataTable
                if (vs != null) {
                    this.dataTable.search(vs.filterSearch)
                                    .page(vs.currentPage)
                                    .order(vs.order)
                                    .draw(false);
                }
            });
        } else {
            this.dataTable.ajax.reload();
        }
    }

    /** Atualizando a pesquisa */
    refresh() {
        this.dataTable?.draw(false);
    }

    private hiddenTableColumns() {
        const columns: any[] = [];
        if (this.isRepresentante) { // Se for representante, ocultamos a coluna do representante
            columns.push({visible:  false, targets: 5});
        }

        // Se não for um usuário do financeiro ocultamos a coluna da análise financeira
        if (!this.clienteAnaliseFinanceiraAuthGuardService.canVisualizar()) {
            columns.push({visible:  false, targets: 12});
        }

        return columns;
    }

    /** Cria a Datatables assíncrona */
    createTable(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            const columns: DataTablesColumnSettings[] = [
                // {
                //     data: null,
                //     className: 'col-options',
                //     render: () => `<a id="edit" title="Editar"><i class="fas fa-pencil-alt" aria-hidden="true"></i></a>`
                // },
                {
                    data: null,
                    className: 'col-options',
                    orderable: false,
                    render: (data, type, row, meta) => {
                        const entity = data as Cliente;

                        // Edit
                        let template = '';

                        // Opções
                        const tableOptions = new ClienteTableOptions();
                        // Edit
                        tableOptions.canEdit = this.optionsVisibility.canEdit;
                        // Imprimir ficha cadastral
                        tableOptions.canPrintFichaCadastral = this.optionsVisibility.canPrintFichaCadastral;
                        // Importar do ERP V1
                        tableOptions.canImportOneErp_v1 = this.optionsVisibility.canImportOneErp_v1 && this.canImportOneErp_v1(entity);
                        // Importar do ERP
                        tableOptions.canImportOneErp = this.optionsVisibility.canImportOneErp && this.canImportOneErp(entity);

                        /** Negócio */
                        // Inserir um negócio
                        tableOptions.canInsertNegocio = this.optionsVisibility.canInsertNegocio && this.clienteAuthGuardService.canInsertNegocio(entity.cadastro);


                        /* Análise Financeira */
                        // Iniciar Análise Financeira
                        tableOptions.canIniciarAnaliseFinanceira = this.optionsVisibility.canIniciarAnaliseFinanceira && this.clienteAnaliseFinanceiraAuthGuardService.canIniciar(entity.statusAnaliseFinanceira);
                        // Cancelar Inicio Análise Financeira
                        tableOptions.canCancelarIniciarAnaliseFinanceira = this.optionsVisibility.canCancelarIniciarAnaliseFinanceira && this.clienteAnaliseFinanceiraAuthGuardService.canCancelarIniciar(entity.statusAnaliseFinanceira);
                        // Concluir Análise Financeira
                        tableOptions.canConcluirAnaliseFinanceira = this.optionsVisibility.canConcluirAnaliseFinanceira && this.clienteAnaliseFinanceiraAuthGuardService.canConcluir(entity.statusAnaliseFinanceira);
                        // Cancelar Inicio Análise Financeira
                        tableOptions.canCancelarConcluirAnaliseFinanceira = this.optionsVisibility.canCancelarConcluirAnaliseFinanceira && this.clienteAnaliseFinanceiraAuthGuardService.canCancelarConcluir(entity.statusAnaliseFinanceira);
                        // Revisar Análise Financeira
                        tableOptions.canRevisarAnaliseFinanceira = this.optionsVisibility.canRevisarAnaliseFinanceira && this.clienteAnaliseFinanceiraAuthGuardService.canRevisar(entity.statusAnaliseFinanceira);

                        // Congelar
                        tableOptions.canCongelar = this.optionsVisibility.canCongelar && this.clienteAuthGuardService.canCongelar(entity.cadastro, entity.situacao);
                        // Desongelar
                        tableOptions.canDescongelar = this.optionsVisibility.canCongelar && this.clienteAuthGuardService.canDescongelar(entity.cadastro, entity.situacao);

                        // Pré-baixar
                        tableOptions.canPreBaixar = this.optionsVisibility.canPreBaixar && this.clienteAuthGuardService.canPreBaixar(entity.cadastro);
                        // Editar pré-baixa
                        tableOptions.canEditPreBaixa = this.optionsVisibility.canEditPreBaixa && this.clienteAuthGuardService.canEditPreBaixa(entity.cadastro, entity.situacao);
                        // Cancelar pré-baixa
                        tableOptions.canCancelarPreBaixa = this.optionsVisibility.canCancelarPreBaixa && this.clienteAuthGuardService.canCancelarPreBaixa(entity.cadastro, entity.situacao);

                        // Baixar
                        tableOptions.canBaixar = this.optionsVisibility.canBaixar && this.clienteAuthGuardService.canBaixar(entity.cadastro, entity.situacao, this.isAdministrador, this.isAtendente, this.isFinanceiro);
                        // Editar baixa
                        tableOptions.canEditBaixa = this.optionsVisibility.canEditBaixa && this.clienteAuthGuardService.canEditBaixa(entity.cadastro, entity.situacao, this.isAdministrador, this.isAtendente, this.isFinanceiro);
                        // Cancelar baixa
                        tableOptions.canCancelarBaixa = this.optionsVisibility.canCancelarBaixa && this.clienteAuthGuardService.canCancelarBaixa(entity.cadastro, entity.situacao, this.isAdministrador, this.isAtendente, this.isFinanceiro);


                        if (tableOptions.hasAnyOption()) {
                            template += `
                                <span class="btn-group dropup table-options">
                                    <button type="button" title="Opções" class="btn btn-link btn-options dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
                                    </button>
                                    <div class="dropdown-menu">
                            `

                            // Edit
                            if (tableOptions.canEdit) {
                                template += `
                                    <a class="dropdown-item" id="edit" title="Editar">
                                        <i class="fas fa-pencil-alt" aria-hidden="true"></i> Editar
                                    </a>
                                `;
                            }

                            // Imprimir ficha cadastral
                            if (tableOptions.canPrintFichaCadastral) {
                                template += `
                                    <a class="dropdown-item" id="printFichaCadastral" title="Imprimir Ficha Cadastral">
                                        <i class="fas fa-print" aria-hidden="true"></i> Imprimir Ficha Cadastral
                                    </a>
                                `;
                            }

                            /** Negócio */
                            // Inserir Negócio
                            if (tableOptions.canInsertNegocio) {
                                template += `
                                    <div class="dropdown-divider"></div>
                                    <a class="dropdown-item" id="insertNegocio">
                                        <i class="fas fa-bullseye"></i> Criar Oportunidade
                                    </a>
                                `;
                            }

                            /** Análise Financeira */
                            if (tableOptions.hasAnyOptionAnaliseFinanceira()) {
                                template += `
                                    <div class="dropdown-divider"></div>
                                    <h6 class="dropdown-header">Análise Financeira</h6>
                                `;
                                // Iniciar Análise Financeira
                                if (tableOptions.canIniciarAnaliseFinanceira) {
                                    template += `
                                        <a class="dropdown-item" id="iniciarAnaliseFinanceira" title="Iniciar Análise Financeira">
                                            <i class="fas fa-play"></i> Iniciar Análise Financeira
                                        </a>
                                    `;
                                }
                                // Cancelar Inicio Análise Financeira
                                if (tableOptions.canCancelarIniciarAnaliseFinanceira) {
                                    template += `
                                        <a class="dropdown-item" id="cancelarIniciarAnaliseFinanceira" title="Cancelar Inicio Análise Financeira">
                                            <i class="fas fa-ban"></i> Cancelar Inicio Análise Financeira
                                        </a>
                                    `;
                                }
                                // Concluir Análise Financeira
                                if (tableOptions.canConcluirAnaliseFinanceira) {
                                    template += `
                                        <a class="dropdown-item" id="concluirAnaliseFinanceira" title="Concluir Análise Financeira">
                                            <i class="fas fa-check"></i> Concluir Análise Financeira
                                        </a>
                                    `;
                                }
                                // Cancelar Inicio Análise Financeira
                                if (tableOptions.canCancelarConcluirAnaliseFinanceira) {
                                    template += `
                                        <a class="dropdown-item" id="cancelarConcluirAnaliseFinanceira" title="Cancelar Conclusão Análise Financeira">
                                            <i class="fas fa-ban"></i> Cancelar Conclusão Análise Financeira
                                        </a>
                                    `;
                                }
                                // Revisar Análise Financeira
                                if (tableOptions.canRevisarAnaliseFinanceira) {
                                    template += `
                                        <a class="dropdown-item" id="revisarAnaliseFinanceira" title="Revisar Análise Financeira">
                                            <i class="far fa-edit"></i> Revisar Análise Financeira
                                        </a>
                                    `;
                                }
                            }

                            /** Congelar */
                            if (tableOptions.hasCongelamentoOptions()) {
                                template += `
                                    <div class="dropdown-divider"></div>
                                `;
                                // Congelar
                                if (tableOptions.canCongelar) {
                                    template += `
                                        <a class="dropdown-item dropdown-item-congelar-cliente" id="congelar">
                                            <i class="fas fa-snowflake"></i> Congelar Cliente
                                        </a>
                                    `;
                                }
                                // Descongelar
                                if (tableOptions.canDescongelar) {
                                    template += `
                                        <a class="dropdown-item dropdown-item-congelar-cliente" id="descongelar">
                                            <i class="fas fa-snowflake"></i> Descongelar Cliente
                                        </a>
                                    `;
                                }
                            }

                            /** Pré-Baixar */
                            if (tableOptions.hasPreBaixarOptions()) {
                                template += `
                                    <div class="dropdown-divider"></div>
                                    <h6 class="dropdown-header">Pré-Baixar</h6>
                                `;
                                // Pré-baixar
                                if (tableOptions.canPreBaixar) {
                                    template += `
                                        <a class="dropdown-item dropdown-item-prebaixar" id="preBaixar">
                                            <i class="far fa-window-close"></i> Pré-Baixar Cliente
                                        </a>
                                    `;
                                }
                                // Editar pré-baixa
                                if (tableOptions.canEditPreBaixa) {
                                    template += `
                                        <a class="dropdown-item dropdown-item-prebaixar" id="editPreBaixa">
                                            <i class="far fa-edit"></i> Editar Pré-Baixa
                                        </a>
                                    `;
                                }
                                // Cancelar pré-baixa
                                if (tableOptions.canCancelarPreBaixa) {
                                    template += `
                                        <a class="dropdown-item" id="cancelarPreBaixa">
                                            <i class="fas fa-undo-alt"></i> Cancelar Pré-Baixa
                                        </a>
                                    `;
                                }
                            }

                            /** Baixar */
                            if (tableOptions.hasBaixarOptions()) {
                                template += `
                                    <div class="dropdown-divider"></div>
                                    <h6 class="dropdown-header">Baixar</h6>
                                `;
                                // Baixar
                                if (tableOptions.canBaixar) {
                                    template += `
                                        <a class="dropdown-item dropdown-item-baixar" id="baixar">
                                            <i class="far fa-window-close"></i> Baixar Cliente
                                        </a>
                                    `;
                                }
                                // Editar baixa
                                if (tableOptions.canEditBaixa) {
                                    template += `
                                        <a class="dropdown-item dropdown-item-baixar" id="editBaixa">
                                            <i class="far fa-edit"></i> Editar Baixa
                                        </a>
                                    `;
                                }
                                // Cancelar baixa
                                if (tableOptions.canCancelarBaixa) {
                                    template += `
                                        <a class="dropdown-item" id="cancelarBaixa">
                                            <i class="fas fa-undo-alt"></i> Cancelar Baixa
                                        </a>
                                    `;
                                }
                            }

                            // Import One ERP V1
                            if (tableOptions.canImportOneErp_v1) {
                                template += `
                                    <div class="dropdown-divider"></div>
                                    <a class="dropdown-item" id="importOneErp_v1" title="Importar do ERP">
                                        <i class="fas fa-download"></i> Importar do ERP
                                    </a>
                                `;
                            }

                            // Import One ERP
                            if (tableOptions.canImportOneErp) {
                                template += `
                                    <div class="dropdown-divider"></div>
                                    <a class="dropdown-item" id="importOneErp" title="Importar do ERP">
                                        <i class="fas fa-download"></i> Importar do ERP
                                    </a>
                                `;
                            }

                            template += `
                                    </div>
                                </span>
                            `;
                        }

                        return template;
                    },
                    createdCell: (td, cellData, rowData, row, col) => {
                        const entity = cellData as Cliente;

                        const dropdown = jQuery(td).find('.btn-group');
                        // Ao abrir o dropdown, adicionamos ele no body para exibi-lo corretamente na table
                        dropdown.on('show.bs.dropdown', function() {
                            jQuery('body').append(dropdown.css({
                                    position: 'absolute',
                                    left: dropdown.offset().left,
                                    top: dropdown.offset().top
                                }).detach());
                        });
                        // Ai fechar o dropdown, adicionamos ele novamente a coluna das opções na table
                        dropdown.on('hidden.bs.dropdown', function() {
                            jQuery(td).append(dropdown.css({
                                position: 'relative',
                                left: 'auto',
                                top: 'auto'
                            }).detach());
                        });

                        // Vinculando os eventos de click das opções da tabela
                        const myself = this;
                        // Opções fora do dropdown
                        jQuery(td).on('click', 'a', function() {
                            if (this.id === 'edit') {
                                myself.edit(entity);
                            }
                        });
                        // Opções do dropdown
                        dropdown.on('click', 'a', function() {
                            if (this.id === 'edit') {
                                myself.edit(entity);
                            } else if (this.id === 'printFichaCadastral') {
                                myself.printFichaCadastral(entity);
                            } else if (this.id === 'insertNegocio') {
                                myself.insertNegocio(entity);
                            } else if (this.id === 'importOneErp_v1') {
                                myself.importOneErp_v1(entity);
                            } else if (this.id === 'importOneErp') {
                                myself.importOneErp(entity);
                            } else if (this.id === 'iniciarAnaliseFinanceira') {
                                myself.iniciarAnaliseFinanceira(entity);
                            } else if (this.id === 'cancelarIniciarAnaliseFinanceira') {
                                myself.cancelarIniciarAnaliseFinanceira(entity);
                            } else if (this.id === 'concluirAnaliseFinanceira') {
                                myself.concluirAnaliseFinanceira(entity);
                            } else if (this.id === 'cancelarConcluirAnaliseFinanceira') {
                                myself.cancelarConcluirAnaliseFinanceira(entity);
                            } else if (this.id === 'revisarAnaliseFinanceira') {
                                myself.revisarAnaliseFinanceira(entity);
                            } else if (this.id === 'congelar') {
                                myself.congelar(entity);
                            } else if (this.id === 'descongelar') {
                                myself.descongelar(entity);
                            } else if (this.id === 'preBaixar') {
                                myself.preBaixar(entity);
                            } else if (this.id === 'editPreBaixa') {
                                myself.editPreBaixa(entity);
                            } else if (this.id === 'cancelarPreBaixa') {
                                myself.cancelarPreBaixa(entity);
                            } else if (this.id === 'baixar') {
                                myself.baixar(entity);
                            } else if (this.id === 'editBaixa') {
                                myself.editBaixa(entity);
                            } else if (this.id === 'cancelarBaixa') {
                                myself.cancelarBaixa(entity);
                            }
                        });
                    }
                },
                {
                    data: 'pessoa.codigoIntegracaoErp',
                    className: 'col-codigo-integracao-erp',
                    serverOrderByColumn: ClienteSearchOrderBy.CodigoIntegracaoErp
                },
                {
                    data: 'pessoa.nome',
                    className: 'col-nome',
                    serverOrderByColumn: ClienteSearchOrderBy.Nome,
                    render: (data: any, _: any, entity: Cliente) => {
                        let nome = data;
                        if (!this.isRepresentante && !entity.clientePrimario) {
                            nome += '<span class="badge badge-primary badge-cliente-secundario" title="Isto significa que este cliente foi cadastrado a partir de um outro cadastro de cliente com o mesmo CNPJ/CPF">Secundário</span>'
                        }
                        return nome;
                    },
                    createdCell: (td, cellData, rowData, row, col) => {
                        if (cellData) {
                            td.title = cellData;
                        }
                    }
                },
                {
                    data: 'pessoa.nomeFantasia',
                    className: 'col-nome-fantasia',
                    serverOrderByColumn: ClienteSearchOrderBy.NomeFantasia,
                    createdCell: (td, cellData, rowData, row, col) => {
                        if (cellData) {
                            td.title = cellData;
                        }
                    },
                },
                {
                    data: 'pessoa.cnpjCpf',
                    className: 'col-cnpj-cpf',
                    serverOrderByColumn: ClienteSearchOrderBy.CnpjCpf,
                },
                {
                    data: 'representante',
                    className: 'col-nome-representante',
                    serverOrderByColumn: ClienteSearchOrderBy.RepresentanteNome,
                    render: (data: Representante, _: any, entity: Cliente) => {
                        if (data && data.pessoa) {
                            return ` ${data.pessoa.codigoIntegracaoErp} - ${createNomeRepresentante(this.configEmpresa.identificacaoRepresentante, data.pessoa.nome, data.pessoa.nomeFantasia)} `;
                        }
                        return '';
                    },
                    createdCell: (td, cellData: Representante, rowData, row, col) => {
                        if (cellData) {
                            td.title = ` ${cellData.pessoa.codigoIntegracaoErp} - ${createNomeRepresentante(this.configEmpresa.identificacaoRepresentante, cellData.pessoa.nome, cellData.pessoa.nomeFantasia)} `;
                        }
                    }
                },
                {
                    data: null,
                    className: 'col-tipo-pessoa text-center',
                    serverOrderByColumn: ClienteSearchOrderBy.TipoPessoa,
                    createdCell: (td: any, cellData: any, entity: Cliente) => {
                        if (entity.statusAnaliseFinanceira) {
                            // Criando o badge
                            const badgeFactory = this.componentFactoryResolver.resolveComponentFactory(PessoaTipoBadgeComponent);
                            const badgeRef = this.pessoaTipoBadgeContainer.createComponent(badgeFactory);
                            badgeRef.instance.tipo = entity.pessoa?.tipo ?? null;
                            badgeRef.instance.quantidadeParticipantesCentralCompras = entity.quantidadeParticipantesCentralCompras;
                            // Inserindo o badge na table cell
                            this.renderer.appendChild(td, badgeRef.location.nativeElement);
                        }
                    },
                    render: () => ''
                },
                {
                    data: 'cadastro',
                    className: 'col-cadastro text-center',
                    serverOrderByColumn: ClienteSearchOrderBy.Cadastro,
                    render: (data: number) => `<span class="${this.clienteCadastroBadgePipe.transform(data)}">${this.clienteCadastroPipe.transform(data)}</span>`
                },
                {
                    data: 'situacao',
                    className: 'col-situacao text-center',
                    serverOrderByColumn: ClienteSearchOrderBy.Situacao,
                    render: (data: number) => `<span class="${this.clienteSituacaoBadgePipe.transform(data)}">${this.clienteSituacaoPipe.transform(data)}</span>`
                },
                {
                    data: 'origem',
                    className: 'col-origem',
                    serverOrderByColumn: ClienteSearchOrderBy.Origem,
                    render: (data: number) => {
                        if (data) {
                            return `
                                <i class="${this.origemIconPipe.transform(data)}"></i>
                                <span>${this.origemPipe.transform(data)}</span>
                            `;
                        }
                        return '';
                    },
                    createdCell: (td, cellData, rowData, row, col) => {
                        if (cellData) {
                            td.title = this.origemPipe.transform(cellData);
                        }
                    }
                },
                {
                    data: 'canalMidiaSocial',
                    className: 'col-canal-midia-social',
                    serverOrderByColumn: ClienteSearchOrderBy.CanalMidiaSocial,
                    render: (data: number) => {
                        if (data) {
                            return `
                                <i class="${this.canalMidiaSocialIconPipe.transform(data)}"></i>
                                <span>${this.canalMidiaSocialPipe.transform(data)}</span>
                            `;
                        }
                        return '';
                    },
                    createdCell: (td, cellData, rowData, row, col) => {
                        if (cellData) {
                            td.title = this.canalMidiaSocialPipe.transform(cellData);
                        }
                    }
                },
                {
                    data: 'nomeCampanhaOrigem',
                    className: 'col-nome-campanha',
                    serverOrderByColumn: ClienteSearchOrderBy.NomeCampanhaOrigem,
                    createdCell: (td, cellData, rowData, row, col) => {
                        if (cellData) {
                            td.title = cellData;
                        }
                    }
                },
                {
                    data: 'nomeCampanhaAquisicao',
                    className: 'col-nome-campanha',
                    serverOrderByColumn: ClienteSearchOrderBy.NomeCampanhaAquisicao,
                    createdCell: (td, cellData, rowData, row, col) => {
                        if (cellData) {
                            td.title = cellData;
                        }
                    }
                },
                {
                    data: null,
                    // visible: this.isFinanceiro,
                    className: 'col-status-analise-financeira text-center',
                    serverOrderByColumn: 6,
                    createdCell: (td: any, cellData: any, entity: Cliente) => {
                        if (entity.statusAnaliseFinanceira) {
                            // Criando o badge
                            const badgeFactory = this.componentFactoryResolver.resolveComponentFactory(ClienteAnaliseFinanceiraStatusBadgeComponent);
                            const badgeRef = this.analiseFinanceiraStatusBadgeContainer.createComponent(badgeFactory);
                            badgeRef.instance.status = entity.statusAnaliseFinanceira;
                            // Inserindo o badge na table cell
                            this.renderer.appendChild(td, badgeRef.location.nativeElement);
                        }
                    },
                    render: () => ''
                }
            ];

            this.dataTablesService.showTable(`#${this.idDataTable}`, this.dataTable, {
                columnDefs: this.hiddenTableColumns(),
                columns,
                order: [[2, 'asc']], // nome asc
                searching: false,
                info: false,
                serverSide: true,
                processing: true,
                deferRender: true,
                scroller: true,
                scrollX: true,
                ajax: (data, callback, settings) => { // Evento Ajax para pesquisar os clientes
                    // OrderBy
                    const order = data?.order[0];
                    const orderColumn = columns[order?.column];
                    this.orderBy = orderColumn?.serverOrderByColumn;
                    this.orderByChanged.emit(this.orderBy);
                    this.orderByDir = order?.dir;
                    this.orderByDirChanged.emit(this.orderByDir);

                    this.searchSubs$.add(this.clienteCrudHttpService.searchWithFilter(this.filter, data.draw, data.start, data.length, this.orderBy, this.orderByDir)
                        .subscribe(
                            response => {
                                this.quantidadeClientes = response?.recordsTotal ?? 0;
                                callback({recordsTotal: response.recordsTotal, recordsFiltered: response.recordsFiltered, data: response.data});
                            },
                            (error: ApiError) => {
                                this.messageService.error(error.message, 'Erro ao pesquisar os clientes', error);
                                this.quantidadeClientes = 0;
                                callback({recordsTotal: 0, recordsFiltered: 0, data: []});
                            }
                        ));
                }
            })
            .then(dataTable => {
                this.dataTable = dataTable;
                this.dataTable
                    .on('preDraw', () => { // Antes de redesenhar a table
                        this.clearPessoaTipoBadgeContainer();
                        this.clearAnaliseFinanceiraStatusBadgeContainer();
                    });

                    setTimeout(() => {
                        // Adicionando evento handler no scroll do body da datatable
                        jQuery(this.el.nativeElement).find('.dataTables_scrollBody').on('scroll', () => {
                            this.visualizacaoStorageService.set(null, null, this.dataTable?.page?.info()?.page, this.dataTable?.order(), this.dataTable?.scroller?.page()?.start, this.visualizacaoStorageKey);
                        });

                        resolve();
                    }, 500);
            });
        });
    }

    /** Limpa o container dos badges do tipo da pessoa criados e inseridos dinamicamente na table */
    private clearPessoaTipoBadgeContainer() {
        this.pessoaTipoBadgeContainer?.clear();
    }

    /** Verifica se pode importar do ERP V1 */
    private canImportOneErp_v1(entity: Cliente): boolean {
        if (!entity) {
            return false;
        }
        // Somente se for a versão 1
        if (!this.isIntegracaoErpV1) {
            return false;
        }
        // Se o cliente ainda não possui o código de integração, então não pode sincronizar com o ERP
        if (!entity.pessoa || !entity.pessoa.codigoIntegracaoErp) {
            return false;
        }
        // Se o cliente ainda não estiver integrado, então não pode sincronizar com o ERP
        if (!entity.integradoErp) {
            return false;
        }

        return this.authService.podeImportarErp();
    }

    /** Verifica se pode importar o cliente do ERP */
    private canImportOneErp(entity: Cliente): boolean {
        if (!entity) {
            return false;
        }

        // Somente se não for a versão 1
        if (this.isIntegracaoErpV1) {
            return false;
        }

        // Somente se estiver integrado com o ERP
        if (!entity.idIntegracaoErp) {
            return false;
        }


        return this.authService.podeImportarErp();
    }

    private edit(entity: Cliente) {
        this.baseVisualizacaoService.edit(entity.id, this.activatedRoute);
    }

    /** Realiza a impressão da ficha cadastral do cliente */
    private printFichaCadastral(entity: Cliente) {
        if (!entity) {
            return;
        }
        this.clienteReportService.printFichaCadastral(entity.id);
    }

    /* Insere um negócio para o prospect/cliente informado **/
    private insertNegocio(entity: Cliente) {
        if (!entity) {
            return;
        }
        this.formInsertModal.insert(null, funilVendaFaseTipoOportunidade, null, entity.id);
    }

    /** Após criar a oportunidade de negócio */
    // onAfterCreateOportunidade(entity: NegocioOportunidadeSearch) {
    //     this.formOportunidadeModal.open(entity);
    // }

    /** Executa a importação do cliente do ERP V1 */
    private importOneErp_v1(entity: Cliente) {
        if (!entity) {
            return;
        }

        const codigoIntegracaoErp = (entity && entity.pessoa && entity.pessoa.codigoIntegracaoErp) ? entity.pessoa.codigoIntegracaoErp : '';
        const task = new Task(`Importando cliente ${codigoIntegracaoErp}`, `Executando importação do cliente ${codigoIntegracaoErp} do ERP`);
        this.taskService.add(task, task.description);
        this.integrationClienteHttpService.execReadIndividualIntegration(entity.id)
            .subscribe(
                () => {
                    this.taskService.success(task, `Importação do cliente ${codigoIntegracaoErp} do sistema ERP realizada com sucesso`);
                    this.refresh();
                },
                (error: ApiError) => this.taskService.error(task, error.message, error.cause, error)
            );
    }

    /** Executa a importação do cliente do ERP */
    private importOneErp(entity: Cliente) {
        if (!entity) {
            return;
        }

        const codigoIntegracaoErp = (entity && entity.pessoa && entity.pessoa.codigoIntegracaoErp) ? entity.pessoa.codigoIntegracaoErp : '';
        const task = new Task(`Importando cliente ${codigoIntegracaoErp}`, `Executando importação do cliente ${codigoIntegracaoErp} do ERP`);
        this.taskService.add(task, task.description);
        this.clienteIntegracaoErpImportHttpService.importOne(entity.id)
            .subscribe(
                () => {
                    this.taskService.success(task, `Importação do cliente ${codigoIntegracaoErp} do sistema ERP realizada com sucesso`);
                    this.refresh();
                },
                (error: ApiError) => this.taskService.error(task, error.message, error.cause, error)
            );
    }

    /** Análise Financeira */

    /** Inicia a análise financeira do cliente */
    private iniciarAnaliseFinanceira(entity: Cliente) {
        const nomeCliente = this.clienteNomePipe.transform(entity.pessoa?.nome, entity.pessoa?.nomeFantasia, entity.pessoa?.codigoIntegracaoErp);
        this.messageService.confirm(`Deseja realmente iniciar a análise financeira do cliente ${nomeCliente}?`).then((result) => {
            if (result) {
                this.clienteAnaliseFinanceiraIniciarHttpService.iniciar(entity.id)
                    .pipe(
                        take(1)
                    )
                    .subscribe(
                        () => {
                            this.messageService.success('', `Análise Financeira do cliente ${nomeCliente} iniciada com sucesso`);
                            this.refresh();
                        },
                        (error: ApiError) => this.messageService.error(error.message, error.cause, error)
                    );
            }
        });
    }

    /** Cancela o inicio da análise financeira do cliente */
    private cancelarIniciarAnaliseFinanceira(entity: Cliente) {
        const nomeCliente = this.clienteNomePipe.transform(entity.pessoa?.nome, entity.pessoa?.nomeFantasia, entity.pessoa?.codigoIntegracaoErp);
        this.messageService.confirm(`Deseja realmente cancelar o inicio da análise financeira do cliente ${nomeCliente}?`).then((result) => {
            if (result) {
                this.clienteAnaliseFinanceiraIniciarHttpService.cancelarIniciar(entity.id)
                    .pipe(
                        take(1)
                    )
                    .subscribe(
                        () => {
                            this.messageService.success('', `Inicio da Análise Financeira do cliente ${nomeCliente} cancelada com sucesso`);
                            this.refresh();
                        },
                        (error: ApiError) => this.messageService.error(error.message, error.cause, error)
                    );
            }
        });
    }

    /** Abre modal para concluir a análise financeira do cliente */
    private concluirAnaliseFinanceira(entity: Cliente) {
        this.analiseFinanceiraConcluirModal?.open(entity?.id);
    }

    /** Após concluir a análise financeira do cliente */
    onAfterConcluirAnaliseFinanceira() {
        this.refresh();
    }

    /** Cancela a conclusão da análise financeira do cliente*/
    private cancelarConcluirAnaliseFinanceira(entity: Cliente) {
        const nomeCliente = this.clienteNomePipe.transform(entity.pessoa?.nome, entity.pessoa?.nomeFantasia, entity.pessoa?.codigoIntegracaoErp);
        this.messageService.confirm(`Deseja realmente cancelar a conclusão da análise financeira do cliente ${nomeCliente}?`).then((result) => {
            if (result) {
                this.clienteAnaliseFinanceiraConcluirHttpService.cancelarConcluir(entity.id)
                    .pipe(
                        take(1)
                    )
                    .subscribe(
                        cliente => {
                            this.messageService.success('', `Conclusão da Análise Financeira do cliente ${nomeCliente} cancelada com sucesso`);
                            this.refresh();
                        },
                        (error: ApiError) => this.messageService.error(error.message, error.cause, error)
                    );
            }
        });
    }

    /** Abre modal para revisar a análise financeira do cliente */
    private revisarAnaliseFinanceira(entity: Cliente) {
        this.analiseFinanceiraRevisarModal?.open(entity?.id);
    }

    /** Após revisar a análise financeira do cliente */
    onAfterRevisarAnaliseFinanceira() {
        this.refresh();
    }

    /** Limpa o container dos badges do status da análise de mercado criados e inseridos dinamicamente na table */
    private clearAnaliseFinanceiraStatusBadgeContainer() {
        this.analiseFinanceiraStatusBadgeContainer?.clear();
    }

    /** Abre o modal para congelar um cliente */
    congelar(entity: Cliente) {
        this.clienteCarteiraCongelarModal?.insert(entity?.id);
    }

    /** Descongela um cliente congelado */
    descongelar(entity: Cliente) {
        if (!entity) {
            return;
        }
        const nomeCliente = this.clienteNomePipe.transform(entity.pessoa?.nome, entity.pessoa?.nomeFantasia, entity.pessoa?.codigoIntegracaoErp);
        this.messageService.confirm(`Deseja realmente descongelar o cliente ${nomeCliente}?`, 'Confirme')
            .then(result => {
                if (result) {
                    this.clienteCarteiraCongelarHttpService.descongelar(entity.id)
                        .pipe(
                            take(1)
                        )
                        .subscribe(
                            () => {
                                this.messageService.success('', `Cliente ${nomeCliente} descongelado com sucesso`);
                                this.refresh();
                            },
                            (error: ApiError) => this.messageService.error(error.message, error.cause, error)
                        );
                }
            });
    }


    /** Abre o modal para pré-baixar um cliente */
    preBaixar(entity: Cliente) {
        this.clienteCarteiraPreBaixarModal?.insert(entity?.id);
    }

    /** Abre o modal para editar a pré-baixa de um cliente */
    editPreBaixa(entity: Cliente) {
        this.clienteCarteiraPreBaixarModal?.edit(entity.id);
    }

    /** Realiza o cancelamento da pré-baixa do cliente */
    cancelarPreBaixa(entity: Cliente) {
        if (!entity) {
            return;
        }

        const nomeCliente = this.clienteNomePipe.transform(entity.pessoa?.nome, entity.pessoa?.nomeFantasia, entity.pessoa?.codigoIntegracaoErp);
        this.messageService.confirm(`Deseja realmente cancelar a pré-baixa do cliente ${nomeCliente}?`, 'Confirme').then(result => {
            if (result) {
                this.clienteCarteiraPreBaixarHttpService.cancelarPreBaixa(entity.id)
                    .pipe(
                        take(1)
                    )
                    .subscribe(
                        () => {
                            this.messageService.success('', `Pré-baixa do cliente ${nomeCliente} cancelada com sucesso`);
                            this.refresh();
                        },
                        (error: ApiError) => {
                            this.messageService.error(error.message, `Erro ao cancelar a pré-baixa do cliente ${nomeCliente}`);
                        }
                    );
            }
        });
    }

    /** Abre o modal para baixar um cliente */
    baixar(entity: Cliente) {
        this.clienteCarteiraBaixarModal?.insert(entity?.id, entity?.motivoBaixa);
    }

    /** Abre o modal para editar a baixa de um cliente */
    editBaixa(entity: Cliente) {
        this.clienteCarteiraBaixarModal?.edit(entity.id);
    }

    /** Realiza o cancelamento da baixa do cliente */
    cancelarBaixa(entity: Cliente) {
        if (!entity) {
            return;
        }

        const nomeCliente = this.clienteNomePipe.transform(entity.pessoa?.nome, entity.pessoa?.nomeFantasia, entity.pessoa?.codigoIntegracaoErp);
        this.messageService.confirm(`Deseja realmente cancelar a baixa do cliente ${nomeCliente}?`, 'Confirme').then(result => {
            if (result) {
                this.clienteCarteiraBaixarHttpService.cancelarBaixa(entity.id)
                    .pipe(
                        take(1)
                    )
                    .subscribe(
                        () => {
                            this.messageService.success('', `Baixa do cliente ${nomeCliente} cancelada com sucesso`);
                            this.refresh();
                        },
                        (error: ApiError) => {
                            this.messageService.error(error.message, `Erro ao cancelar a baixa do cliente ${nomeCliente}`);
                        }
                    );
            }
        });
    }

    ngOnDestroy(): void {
        // Realizando unsubscribe dos subscriptions das pesquisas
        this.searchSubs$?.unsubscribe();

        // Removendo evento de scroll do body da datatable
        jQuery(this.el.nativeElement).find('.dataTables_scrollBody').off('scroll');

        this.clearPessoaTipoBadgeContainer();
        this.clearAnaliseFinanceiraStatusBadgeContainer();
    }
}
